"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsModernOrderingEnabled = exports.isAccountOwner = exports.UserKey = exports.impersonateInfo = exports.IsWebView = void 0;
exports.IsWebView = 'isWebView';
exports.impersonateInfo = {
    targetUserId: 'targetUserId',
    targetUserKey: 'targetUserKey',
    targetBrandId: 'targetBrandId',
};
exports.UserKey = 'UserKey';
exports.isAccountOwner = 'isAccountOwner';
exports.IsModernOrderingEnabled = 'isModernOrderingEnabled';
//# sourceMappingURL=Constants.js.map